<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <LoaderApi :apiUrl="`portal/service-desk/order/${$route.params.id}`">
          <template slot-scope="orderData">
            <div v-if="orderData && orderData.data">
              <!-- Header da O.S -->
              <v-card class="order-header-card mb-6" elevation="3" :style="{ borderLeftColor: orderData.data.category.color }">
                <v-card-text class="pa-6">
                  <div class="d-flex align-center justify-space-between">
                    <div class="d-flex align-center">
                      <v-avatar 
                        :color="orderData.data.category.color" 
                        size="64"
                        class="mr-4 elevation-4"
                      >
                        <v-icon color="white" size="32">{{ orderData.data.category.icon }}</v-icon>
                      </v-avatar>
  <div>
                        <h1 class="text-h5 font-weight-bold mb-2" :style="{ color: orderData.data.category.color }">
                          {{ orderData.data.category.name }}
                        </h1>
                        <div class="d-flex align-center">
                          <div class="mr-3 id-container">
                            <span class="id-text">#{{ orderData.data.id }}</span>
                          </div>
                          <v-chip 
                            large
                            class="status-chip"
                            :style="{ 
                              background: `linear-gradient(135deg, ${orderData.data.status.color}, ${adjustColorBrightness(orderData.data.status.color, -20)})`,
                              color: 'white',
                              border: `2px solid ${adjustColorBrightness(orderData.data.status.color, -30)}`
                            }"
                          >
                            <v-icon left>{{ orderData.data.status.icon }}</v-icon>
                            {{ orderData.data.status.name }}
                          </v-chip>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Botão de Acessar Relatório -->
                    <div class="text-center">
                      <v-btn
                        x-large
                        class="report-btn elevation-4"
                        :style="{ background: `linear-gradient(135deg, ${orderData.data.category.color}, ${adjustColorBrightness(orderData.data.category.color, -15)})` }"
                        @click="accessReport"
                      >
                        <v-icon left large>assessment</v-icon>
                        Acessar Relatório da O.S
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Informações Básicas e Localização -->
              <v-row class="equal-height-cards">
                <!-- Coluna Esquerda - Informações Básicas -->
                <v-col cols="12" md="6" class="d-flex">
                  <v-card class="info-card mb-4" elevation="2" :style="{ borderLeft: `4px solid ${orderData.data.category.color}` }">
                    <v-card-title class="info-card-title" :style="{ background: `linear-gradient(135deg, ${orderData.data.category.color}, ${adjustColorBrightness(orderData.data.category.color, -20)})` }">
                      <v-icon color="white" class="mr-2">info</v-icon>
                      <span class="text-subtitle-1">Informações Básicas</span>
                    </v-card-title>
                    <v-card-text class="pa-4">
                      <div class="info-grid">
                        <div class="info-item id-item" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -10)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -10)" size="18" class="mr-2">tag</v-icon>
                            <span class="info-label">ID da Ordem:</span>
                          </div>
                          <div class="id-background">
                            <span class="info-value">#{{ orderData.data.id }}</span>
                          </div>
                        </div>
                        <div class="info-item code-item" v-if="orderData.data.code" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -15)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -15)" size="18" class="mr-2">code</v-icon>
                            <span class="info-label">Código:</span>
                          </div>
                          <div class="code-background">
                            <span class="info-value">{{ orderData.data.code }}</span>
                          </div>
                        </div>
                        <div v-if="orderData.data.well_id" class="info-item well-item" @click="goToWellDetails(orderData.data.well_uuid)" :style="{ 
                          background: `linear-gradient(135deg, ${orderData.data.category.color}, ${adjustColorBrightness(orderData.data.category.color, -15)})`,
                          borderLeft: `4px solid ${adjustColorBrightness(orderData.data.category.color, -30)}`
                        }">
                          <div class="label-with-icon">
                            <v-icon color="white" size="18" class="mr-2">water_drop</v-icon>
                            <span class="info-label well-label">Poço:</span>
                          </div>
                          <div class="well-container">
                            <span class="info-value well-highlight">#{{ orderData.data.well_id }}</span>
                            <v-icon color="white" size="16" class="ml-2">arrow_forward</v-icon>
                          </div>
                        </div>
                        <div class="info-item date-item" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -20)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -20)" size="18" class="mr-2">play_circle_filled</v-icon>
                            <span class="info-label">Data de Início:</span>
                          </div>
                          <div class="date-container">
                            <span class="info-value">{{ orderData.data.date_start }}</span>
                          </div>
                        </div>
                        <div class="info-item date-item" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -25)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -25)" size="18" class="mr-2">check_circle</v-icon>
                            <span class="info-label">Data de Conclusão:</span>
                          </div>
                          <div class="date-container">
                            <span class="info-value">{{ orderData.data.date_end }}</span>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Coluna Direita - Localização -->
                <v-col cols="12" md="6" class="d-flex">
                  <v-card class="info-card mb-4" elevation="2" v-if="orderData.data.address" :style="{ borderLeft: `4px solid ${orderData.data.category.color}` }">
                    <v-card-title class="info-card-title" :style="{ background: `linear-gradient(135deg, ${orderData.data.category.color}, ${adjustColorBrightness(orderData.data.category.color, -20)})` }">
                      <v-icon color="white" class="mr-2">location_on</v-icon>
                      <span class="text-subtitle-1">Localização</span>
                    </v-card-title>
                    <v-card-text class="pa-4">
                      <div class="address-details">
                        <div class="address-item" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -5)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -5)" size="18" class="mr-2">location_on</v-icon>
                            <span class="address-label">Endereço:</span>
                          </div>
                          <span class="address-value">{{ orderData.data.address.address }}</span>
                        </div>
                        <div class="address-item" v-if="orderData.data.address.number" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -8)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -8)" size="18" class="mr-2">home</v-icon>
                            <span class="address-label">Número:</span>
                          </div>
                          <span class="address-value">{{ orderData.data.address.number }}</span>
                        </div>
                        <div class="address-item" v-if="orderData.data.address.complement" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -12)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -12)" size="18" class="mr-2">add_location</v-icon>
                            <span class="address-label">Complemento:</span>
                          </div>
                          <span class="address-value">{{ orderData.data.address.complement }}</span>
                        </div>
                        <div class="address-item" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -18)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -18)" size="18" class="mr-2">place</v-icon>
                            <span class="address-label">Bairro:</span>
                          </div>
                          <span class="address-value">{{ orderData.data.address.district }}</span>
                        </div>
                        <div class="address-item" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -22)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -22)" size="18" class="mr-2">location_city</v-icon>
                            <span class="address-label">Cidade:</span>
                          </div>
                          <span class="address-value">{{ orderData.data.address.city.name }}</span>
                        </div>
                        <div class="address-item" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -28)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -28)" size="18" class="mr-2">flag</v-icon>
                            <span class="address-label">Estado:</span>
                          </div>
                          <span class="address-value">{{ orderData.data.address.city.state.name }} ({{ orderData.data.address.city.state.code }})</span>
                        </div>
                        <div class="address-item" :style="{ borderLeft: `3px solid ${adjustColorBrightness(orderData.data.category.color, -35)}` }">
                          <div class="label-with-icon">
                            <v-icon :color="adjustColorBrightness(orderData.data.category.color, -35)" size="18" class="mr-2">markunread_mailbox</v-icon>
                            <span class="address-label">CEP:</span>
                          </div>
                          <span class="address-value">{{ orderData.data.address.zip_code }}</span>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Observações -->
              <v-row v-if="orderData.data.observation">
                <v-col cols="12">
                  <v-card class="info-card mb-4" elevation="2" :style="{ borderLeft: `4px solid ${orderData.data.category.color}` }">
                    <v-card-title class="info-card-title" :style="{ background: `linear-gradient(135deg, ${orderData.data.category.color}, ${adjustColorBrightness(orderData.data.category.color, -20)})` }">
                      <v-icon color="white" class="mr-2">note</v-icon>
                      <span class="text-subtitle-1">Observações</span>
                    </v-card-title>
                    <v-card-text class="pa-4">
                      <p class="observation-text">{{ orderData.data.observation }}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Arquivos -->
              <v-card class="files-card mb-4" elevation="2" v-if="orderData.data.files && orderData.data.files.length > 0" :style="{ borderLeft: `4px solid ${orderData.data.category.color}` }">
                <v-card-title class="files-card-title" :style="{ background: `linear-gradient(135deg, ${orderData.data.category.color}, ${adjustColorBrightness(orderData.data.category.color, -20)})` }">
                  <v-icon color="white" class="mr-2">attach_file</v-icon>
                  <span class="text-subtitle-1">Arquivos Anexos</span>
                  <v-spacer></v-spacer>
                  <v-chip 
                    color="white" 
                    small 
                    class="files-count-chip"
                    :style="{ background: `rgba(255, 255, 255, 0.2)`, color: 'white' }"
                  >
                    {{ orderData.data.files.length }} {{ orderData.data.files.length === 1 ? 'arquivo' : 'arquivos' }}
                  </v-chip>
                </v-card-title>
                <v-card-text class="pa-4">
                  <v-row>
                    <v-col 
                      v-for="file in orderData.data.files" 
                      :key="file.url"
                      cols="12" 
                      sm="6" 
                      md="4" 
                      lg="3"
                    >
                      <v-card 
                        class="file-card" 
                        elevation="2" 
                        @click="openFile(file.url)"
                        :style="{ borderLeft: `4px solid ${adjustColorBrightness(orderData.data.category.color, -10)}` }"
                      >
                        <!-- Preview de Imagem -->
                        <div v-if="isImage(file.extension)" class="file-image-preview">
                          <v-img
                            :src="file.url"
                            :alt="file.name"
                            height="120"
                            class="file-preview-img"
                            @error="handleImageError"
                          >
                            <template v-slot:placeholder>
                              <v-row class="fill-height ma-0" align="center" justify="center">
                                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <div class="file-overlay">
                            <v-icon color="white" size="24">visibility</v-icon>
                          </div>
                        </div>
                        
                        <!-- Ícone para outros tipos de arquivo -->
                        <div v-else class="file-icon-container">
                          <div class="file-icon-wrapper" :style="{ background: `linear-gradient(135deg, ${adjustColorBrightness(orderData.data.category.color, -10)}, ${adjustColorBrightness(orderData.data.category.color, -20)})` }">
                            <v-icon color="white" size="32">{{ getFileIcon(file.extension) }}</v-icon>
                          </div>
                          <div class="file-overlay">
                            <v-icon color="white" size="24">open_in_new</v-icon>
                          </div>
                        </div>
                        
                        <!-- Informações do arquivo -->
                        <v-card-text class="pa-3">
                          <div class="file-info">
                            <h4 class="file-name text-subtitle-2 font-weight-bold mb-1" :style="{ color: orderData.data.category.color }">
                              {{ file.name }}
                            </h4>
                            <div class="file-details">
                              <v-chip 
                                small 
                                class="file-extension-chip mb-2"
                                :style="{ 
                                  background: `linear-gradient(135deg, ${adjustColorBrightness(orderData.data.category.color, -15)}, ${adjustColorBrightness(orderData.data.category.color, -25)})`,
                                  color: 'white'
                                }"
                              >
                                {{ file.extension.toUpperCase() }}
                              </v-chip>
                              <p class="file-description text-caption mb-1" v-if="file.description">
                                {{ file.description }}
                              </p>
                              <p class="file-date text-caption grey--text">
                                {{ formatDate(file.created_at) }}
                              </p>
                            </div>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Ações -->
              <v-card class="actions-card" elevation="2">
                <v-card-text class="pa-4">
                  <div class="d-flex justify-center">
                    <v-btn
                      large
                      class="back-btn"
                      :style="{ 
                        background: `linear-gradient(135deg, ${orderData.data.category.color}, ${adjustColorBrightness(orderData.data.category.color, -15)})`,
                        color: 'white'
                      }"
                      @click="goBack"
                    >
                      <v-icon left>arrow_back</v-icon>
                      Voltar
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <!-- Estado de carregamento -->
            <div v-else class="loading-state">
              <v-container class="text-center py-12">
                <v-progress-circular
                  indeterminate
                  color="primary"
                  size="64"
                  class="mb-4"
                ></v-progress-circular>
                <h3 class="text-h6 grey--text">Carregando detalhes da ordem de serviço...</h3>
              </v-container>
  </div>
          </template>
        </LoaderApi>
      </v-col>
    </v-row>

    <!-- Dialog para visualizar PDF -->
    <v-dialog
      v-model="showPdfDialog"
      max-width="95vw"
      max-height="95vh"
      persistent
      scrollable
    >
      <v-card class="pdf-dialog">
        <v-card-title class="pdf-dialog-header">
          <v-icon color="white" class="mr-2">description</v-icon>
          <span>Relatório da Ordem de Serviço</span>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="closePdfDialog"
            color="white"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pdf-dialog-content pa-0">
          <iframe
            v-if="pdfUrl"
            :src="pdfUrl"
            class="pdf-iframe"
            frameborder="0"
            allowfullscreen
          ></iframe>
        </v-card-text>
        
        <v-card-actions class="pdf-dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="openPdfInNewTab"
            class="mr-2"
          >
            <v-icon left>open_in_new</v-icon>
            Abrir em Nova Aba
          </v-btn>
          <v-btn
            color="grey"
            @click="closePdfDialog"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import LoaderApi from "@/default/components/LoaderApi/LoaderApi";

export default {
  name: "Order",
  
  data() {
    return {
      showPdfDialog: false,
      pdfUrl: null
    };
  },
  
  components: {
    LoaderApi
  },
  
  methods: {
    adjustColorBrightness(color, percent) {
      // Remove o # se existir
      const hex = color.replace('#', '');
      
      // Converte para RGB
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      
      // Ajusta o brilho
      const newR = Math.max(0, Math.min(255, r + (r * percent / 100)));
      const newG = Math.max(0, Math.min(255, g + (g * percent / 100)));
      const newB = Math.max(0, Math.min(255, b + (b * percent / 100)));
      
      // Converte de volta para hex
      const toHex = (n) => {
        const hex = Math.round(n).toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };
      
      return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
    },
    
    goBack() {
      this.$router.go(-1);
    },
    
    goToWellDetails(wellId) {
      // Navegar para a página de detalhes do poço
      this.$router.push({ 
        name: 'well', 
        params: { id: wellId } 
      });
    },
    
    accessReport() {
      const orderId = this.$route.params.id;
      
      this.$Api.post({
        url: `portal/service-desk/order/${orderId}/document-pdf`,
        data: { order_id: orderId },
        success: (response) => {
          if (response?.data?.data?.file_url) {
            this.pdfUrl = response.data.data.file_url;
            this.showPdfDialog = true;
          }
        },
        error: (error) => {
          console.error('Erro ao gerar relatório:', error);
          this.errorMessage();
        },
        config: {
          message: {
            loading: {
              show: true,
              title: '📄 Gerando relatório da Ordem de Serviço...',
              text: 'Estamos preparando seu relatório em PDF. Isso pode levar alguns segundos.'
            },
            success: {
              show: true,
              title: 'Relatório gerado com sucesso!',
              text: 'Seu relatório foi criado com sucesso.'
            },
            error: {
              show: true,
              title: 'Erro ao gerar relatório',
              text: 'Não foi possível gerar o relatório no momento. Verifique sua conexão e tente novamente.'
            }
          }
        }
      });
    },
    
    closePdfDialog() {
      this.showPdfDialog = false;
      this.pdfUrl = null;
    },
    
    openPdfInNewTab() {
      if (this.pdfUrl) {
        window.open(this.pdfUrl, '_blank');
      }
    },
    
    errorMessage() {
      this.$swal({
        title: '❌ Ops! Algo deu errado',
        text: 'Não foi possível processar sua solicitação no momento. Por favor, tente novamente em alguns instantes.',
        icon: 'error',
        confirmButtonText: 'Entendi',
        confirmButtonColor: '#f44336'
      });
    },
    
    // Verifica se o arquivo é uma imagem
    isImage(extension) {
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
      return imageExtensions.includes(extension.toLowerCase());
    },
    
    // Retorna o ícone apropriado para cada tipo de arquivo
    getFileIcon(extension) {
      const ext = extension.toLowerCase();
      
      const iconMap = {
        // Documentos
        'pdf': 'picture_as_pdf',
        'doc': 'description',
        'docx': 'description',
        'txt': 'text_snippet',
        'rtf': 'text_snippet',
        
        // Planilhas
        'xls': 'table_chart',
        'xlsx': 'table_chart',
        'csv': 'table_chart',
        
        // Apresentações
        'ppt': 'slideshow',
        'pptx': 'slideshow',
        
        // Arquivos de código
        'js': 'code',
        'html': 'code',
        'css': 'code',
        'php': 'code',
        'py': 'code',
        'java': 'code',
        'cpp': 'code',
        'c': 'code',
        
        // Arquivos de sistema
        'zip': 'archive',
        'rar': 'archive',
        '7z': 'archive',
        'tar': 'archive',
        'gz': 'archive',
        
        // Vídeos
        'mp4': 'video_file',
        'avi': 'video_file',
        'mov': 'video_file',
        'wmv': 'video_file',
        'flv': 'video_file',
        'mkv': 'video_file',
        
        // Áudios
        'mp3': 'audio_file',
        'wav': 'audio_file',
        'flac': 'audio_file',
        'aac': 'audio_file',
        
        // Imagens (fallback)
        'jpg': 'image',
        'jpeg': 'image',
        'png': 'image',
        'gif': 'image',
        'bmp': 'image',
        'webp': 'image',
        'svg': 'image'
      };
      
      return iconMap[ext] || 'insert_drive_file';
    },
    
    // Abre arquivo em nova aba
    openFile(url) {
      window.open(url, '_blank');
    },
    
    // Formata data para exibição
    formatDate(dateString) {
      if (!dateString) return '';
      
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return dateString;
      }
    },
    
    // Trata erro de carregamento de imagem
    handleImageError(event) {
      console.warn('Erro ao carregar imagem:', event);
      // Pode adicionar lógica adicional aqui se necessário
    }
  }
};
</script>

<style scoped>
/* Header da O.S */
.order-header-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px !important;
  border-left: 6px solid #1976D2;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
  transition: all 0.3s ease;
}

.order-header-card:hover {
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12) !important;
}

/* Status chip melhorado */
.status-chip {
  padding: 8px 20px !important;
  border-radius: 20px !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
}

.status-chip:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
}

/* Container do ID no header */
.id-container {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.1), rgba(25, 118, 210, 0.05));
  border-radius: 12px;
  padding: 8px 16px;
  border: 1px solid rgba(25, 118, 210, 0.2);
  height: 40px;
  display: flex;
  align-items: center;
}

.id-text {
  color: #1976D2 !important;
  font-weight: 700 !important;
  font-size: 1.1rem !important;
}

/* Botão de relatório em destaque */
.report-btn {
  border-radius: 16px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  color: white !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  border: none !important;
}

.report-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25) !important;
  filter: brightness(1.1);
}

/* Cards de informação com altura igual */
.equal-height-cards .v-col {
  display: flex;
  flex-direction: column;
}

.equal-height-cards .info-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%; /* Garante que o card ocupe toda a largura da coluna */
}

.equal-height-cards .info-card .v-card-text {
  flex: 1;
}

/* Cards de informação */
.info-card {
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06) !important;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  width: 100%; /* Garante largura total */
  margin-bottom: 16px; /* Espaçamento consistente */
}

.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.12) !important;
}

.info-card-title {
  color: white !important;
  border-radius: 12px 12px 0 0 !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Grid de informações */
.info-grid {
  display: grid;
  gap: 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: rgba(25, 118, 210, 0.05);
  border-radius: 8px;
  border-left: 3px solid #1976D2;
  min-height: 48px;
}

.label-with-icon {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-width: 140px;
  justify-content: flex-start;
}

.info-label {
  color: #666;
  font-weight: 500;
  font-size: 0.9rem;
}

.info-value {
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.95rem;
  text-align: right;
  flex: 1;
}

/* Poço destacado e clicável */
.well-item {
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px !important;
  color: white !important;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
  position: relative;
  overflow: hidden;
}

.well-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.05));
  pointer-events: none;
}

.well-item:hover {
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.25) !important;
}

.well-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  z-index: 1;
}

.well-label {
  color: white !important;
  font-weight: 600 !important;
  opacity: 0.9;
}

.well-highlight {
  color: white !important;
  font-weight: 800 !important;
  font-size: 1.2rem !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* ID e Código com background */
.id-item .id-background {
  background: linear-gradient(135deg, rgba(25, 118, 210, 0.1), rgba(25, 118, 210, 0.05));
  border-radius: 8px;
  padding: 6px 12px;
  border: 1px solid rgba(25, 118, 210, 0.2);
  display: inline-block;
}

.id-item .info-value {
  color: #1976D2 !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
}

.code-item .code-background {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.05));
  border-radius: 8px;
  padding: 6px 12px;
  border: 1px solid rgba(76, 175, 80, 0.2);
  display: inline-block;
}

.code-item .info-value {
  color: #4CAF50 !important;
  font-weight: 700 !important;
  font-size: 1rem !important;
}

/* Datas destacadas */
.date-item {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.05), rgba(76, 175, 80, 0.1)) !important;
  border-radius: 12px !important;
  border-left: 3px solid #4CAF50 !important;
  transition: all 0.3s ease;
}

.date-item:hover {
  background: linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.15)) !important;
  transform: translateY(-1px);
}

.date-container {
  display: flex;
  align-items: center;
  width: 100%;
}


/* Container de endereço */

.address-details {
  display: grid;
  gap: 12px;
}

.address-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: rgba(25, 118, 210, 0.05);
  border-radius: 8px;
  border-left: 3px solid #1976D2;
  min-height: 48px;
}

.address-label {
  color: #666;
  font-weight: 500;
  font-size: 0.9rem;
}

.address-value {
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.95rem;
  text-align: right;
  flex: 1;
}

/* Observações */
.observation-text {
  color: #2c3e50;
  font-size: 0.95rem;
  line-height: 1.6;
  margin: 0;
  padding: 16px;
  background: rgba(25, 118, 210, 0.05);
  border-radius: 8px;
  border-left: 4px solid #1976D2;
}

/* Card de ações */
.actions-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px !important;
  border: 2px solid #dee2e6;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.actions-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
}

/* Botão de voltar */
.back-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
}

.back-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
  filter: brightness(1.1);
}

/* Estado de carregamento */
.loading-state {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 16px;
  margin: 20px 0;
}

/* Layout das informações básicas e localização */
.equal-height-cards {
  display: flex;
  flex-wrap: wrap;
}

.equal-height-cards .v-col {
  display: flex;
  flex-direction: column;
  width: 100%;
}

@media (min-width: 960px) {
  .equal-height-cards .v-col {
    width: 50%;
  }
}

/* Garantir que observações, arquivos e ações ocupem largura total */
.full-width-section {
  width: 100%;
}

/* Responsividade */
@media (max-width: 768px) {
  .order-header-card .d-flex {
    flex-direction: column;
    align-items: flex-start !important;
  }
  
  .order-header-card .text-center {
    width: 100%;
    margin-top: 16px;
  }
  
  .report-btn {
    width: 100%;
  }
  
  .dates-container {
    gap: 12px;
  }
  
  .date-card {
    padding: 12px;
  }
  
  .info-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .address-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .label-with-icon {
    min-width: auto;
    margin-bottom: 8px;
  }
  
  .info-value {
    text-align: left;
  }
  
  .address-value {
    text-align: left;
  }
  
  .well-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .date-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .equal-height-cards .v-col {
    margin-bottom: 16px;
  }
  
  .status-chip {
    padding: 6px 16px !important;
    font-size: 0.9rem !important;
  }
  
  .id-container {
    padding: 6px 12px;
    height: auto;
  }
}

@media (max-width: 480px) {
  .order-header-card {
    padding: 16px !important;
  }
  
  .info-card-title {
    padding: 12px 16px !important;
  }
  
  .info-card .v-card-text {
    padding: 16px !important;
  }
  
  .actions-card .v-card-text {
    padding: 16px !important;
  }
  
  .back-btn {
    width: 100%;
  }
}

/* Dialog do PDF */
.pdf-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.pdf-dialog-header {
  background: linear-gradient(135deg, #1976D2, #42A5F5);
  color: white !important;
  padding: 16px 24px !important;
  font-weight: 600 !important;
}

.pdf-dialog-content {
  height: 80vh;
  padding: 0 !important;
  background: #f5f5f5;
}

.pdf-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: white;
}

.pdf-dialog-actions {
  background: #f8f9fa;
  padding: 16px 24px !important;
  border-top: 1px solid #e0e0e0;
}

/* Responsividade do dialog */
@media (max-width: 768px) {
  .pdf-dialog-content {
    height: 70vh;
  }
  
  .pdf-dialog-header {
    padding: 12px 16px !important;
  }
  
  .pdf-dialog-actions {
    padding: 12px 16px !important;
    flex-direction: column;
    gap: 8px;
  }
  
  .pdf-dialog-actions .v-btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .pdf-dialog-content {
    height: 60vh;
  }
}

/* Estilos para a seção de arquivos */
.files-card {
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06) !important;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
}

.files-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.12) !important;
}

.files-card-title {
  color: white !important;
  border-radius: 12px 12px 0 0 !important;
  font-weight: 600 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.files-count-chip {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.4) !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  transition: all 0.3s ease !important;
  font-size: 0.75rem !important;
}

/* Cards de arquivo */
.file-card {
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08) !important;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  cursor: pointer;
  overflow: hidden;
  position: relative;
  height: 280px; /* Altura fixa para todos os cards */
  display: flex;
  flex-direction: column;
}

.file-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15) !important;
}

/* Preview de imagem */
.file-image-preview {
  position: relative;
  overflow: hidden;
  flex: 1;
  border-bottom: 2px solid #e0e0e0; /* Borda inferior para separar das informações */
}

.file-preview-img {
  transition: all 0.3s ease;
}

.file-card:hover .file-preview-img {
  transform: scale(1.05);
}

/* Container de ícone para outros arquivos */
.file-icon-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-bottom: 2px solid #e0e0e0; /* Borda inferior para separar das informações */
}

.file-icon-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.file-card:hover .file-icon-wrapper {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

/* Overlay para indicar que é clicável */
.file-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: all 0.3s ease;
  border-radius: 12px 12px 0 0;
}

.file-card:hover .file-overlay {
  opacity: 1;
}

/* Informações do arquivo */
.file-info {
  text-align: center;
  flex-shrink: 0; /* Evita que as informações sejam comprimidas */
}

.file-name {
  color: #2c3e50 !important;
  font-weight: 600 !important;
  line-height: 1.3;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.file-details {
  margin-top: 8px;
}

.file-extension-chip {
  border-radius: 8px !important;
  font-weight: 600 !important;
  font-size: 0.7rem !important;
  height: 20px !important;
  display: flex !important;
  align-items: center !important;
  text-transform: uppercase !important;
}

.file-description {
  color: #666;
  line-height: 1.4;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.file-date {
  font-size: 0.7rem;
  margin-top: 4px;
}

/* Responsividade para arquivos */
@media (max-width: 768px) {
  .file-card {
    margin-bottom: 16px;
    height: 260px; /* Altura ligeiramente menor no tablet */
  }
  
  .file-icon-wrapper {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 480px) {
  .file-card {
    height: 240px; /* Altura menor no mobile */
  }
  
  .file-card .v-card-text {
    padding: 12px !important;
  }
  
  .file-name {
    font-size: 0.8rem !important;
  }
  
  .file-extension-chip {
    font-size: 0.65rem !important;
    height: 18px !important;
  }
  
  .file-date {
    font-size: 0.65rem;
  }
}
</style>